import { render, staticRenderFns } from "./SalesNoteCreateUpdate.vue?vue&type=template&id=afaa756c&scoped=true&"
import script from "./SalesNoteCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./SalesNoteCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SalesNoteCreateUpdate.vue?vue&type=style&index=0&id=afaa756c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaa756c",
  null
  
)

export default component.exports